export const WORK_REPORT_UPDATED_EVENT = 'qcyy-work-report-updated'

/**
 * 首页快捷提交和工作汇总详情页使用同一事件刷新状态，避免页面停留时显示旧的提交结果。
 */
export function notifyWorkReportUpdated() {
  window.dispatchEvent(new CustomEvent(WORK_REPORT_UPDATED_EVENT))
}
